import * as Tone from 'tone';

const STAMP_VOLUME = -6;

// Xylophone and guitar
/*
const xyloSoundC4 = require("url:../src/assets/sounds/xylo_C4.mp3");
const xyloSoundG3 = require("url:../src/assets/sounds/xylo_G3.mp3");
const xyloSoundG6 = require("url:../src/assets/sounds/xylo_G6.mp3");
const guitarSoundA2 = require("url:../src/assets/sounds/guitar_A2.mp3");
const guitarSoundC4 = require("url:../src/assets/sounds/guitar_C4.mp3");
const guitarSoundE2 = require("url:../src/assets/sounds/guitar_E2.mp3");
*/
const kotoSoundA2 = require('url:../src/assets/sounds/koto/A2.mp3');
const kotoSoundB2 = require('url:../src/assets/sounds/koto/B2.mp3');
const kotoSoundC2 = require('url:../src/assets/sounds/koto/C2.mp3');
const kotoSoundD2 = require('url:../src/assets/sounds/koto/D2.mp3');
const kotoSoundE2 = require('url:../src/assets/sounds/koto/E2.mp3');
const kotoSoundF2 = require('url:../src/assets/sounds/koto/F2.mp3');

// Stamps
const birdSound01 = require('url:../src/assets/atmosphere/nature/bird01.mp3');
const birdSound02 = require('url:../src/assets/atmosphere/nature/bird02.mp3');
const birdSound03 = require('url:../src/assets/atmosphere/nature/bird03.mp3');
const birdSound04 = require('url:../src/assets/atmosphere/nature/bird04.mp3');
const yoSound01 = require('url:../src/assets/atmosphere/hiphop/yo.mp3');
const scratchSound01 = require('url:../src/assets/atmosphere/hiphop/scratch01.mp3');
const scratchSound02 = require('url:../src/assets/atmosphere/hiphop/scratch02.mp3');
const scratchSound03 = require('url:../src/assets/atmosphere/hiphop/scratch03.mp3');
const whaleSound01 = require('url:../src/assets/atmosphere/underwater/whale01.wav');

class BrushStampsSamplers {
  constructor() {
    this.samplers = {
      /*
            xylophone: new Tone.Sampler({
                urls: {
                    C4: xyloSoundC4,
                    G3: xyloSoundG3,
                    G6: xyloSoundG6,
                },
                release: 1,
                volume: STAMP_VOLUME
            }).toDestination(),*/
      seal: new Tone.Sampler({
        urls: {
          A2: kotoSoundA2,
          B2: kotoSoundB2,
          C2: kotoSoundC2,
          D2: kotoSoundD2,
          E2: kotoSoundE2,
          F2: kotoSoundF2,
        },
        release: 1,
        volume: STAMP_VOLUME,
      }).toDestination(),
      /*guitar: new Tone.Sampler({
                urls: {
                    A2: guitarSoundA2,
                    C4: guitarSoundC4,
                    E2: guitarSoundE2,
                },
                release: 1,
                volume: STAMP_VOLUME
            }).toDestination(),*/
      bird: new Tone.Sampler({
        urls: {
          A2: birdSound01,
          C4: birdSound01,
          E2: birdSound03,
        },
        volume: STAMP_VOLUME,
      }).toDestination(),
      whale: new Tone.Sampler({
        urls: {
          A2: whaleSound01,
          C4: whaleSound01,
          E2: whaleSound01,
        },
        volume: STAMP_VOLUME,
      }).toDestination(),
      yo: new Tone.Sampler({
        urls: {
          A2: yoSound01,
          C4: yoSound01,
          E2: yoSound01,
        },
        volume: STAMP_VOLUME,
      }).toDestination(),
      scratch: new Tone.Sampler({
        urls: {
          A2: scratchSound01,
          C4: scratchSound02,
          E2: scratchSound03,
        },
        volume: STAMP_VOLUME,
      }).toDestination(),
    };
  }

  play(instrument, pitch) {
    if (instrument in this.samplers) {
      this.samplers[instrument].triggerAttackRelease(
        Tone.Frequency(pitch, 'midi').toFrequency(),
        '5'
      );
    }
  }
}

export { BrushStampsSamplers };
